import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
// import {useEffect} from 'react'; 
import { useParams } from "react-router-dom";
import TabForCreateInvoice from "../CreateInvoice/TabForCreateInvoice";

function EditInvoice() {
  const navigate = useNavigate();
  const { eid } = useParams();


  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/InvoiceListing")}
              />{" "}
              Edit Monthly Invoice
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            {/* <div className="residentHeading">Invoice Details</div>
            <div className="residentContMain"> */}
              <TabForCreateInvoice  name={eid}/>
            {/* </div> */}
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default EditInvoice;
